import React from "react";
import SlidingButton from "./SlidingButton";

const options = [
    { key: "yes", value: "Yes" },
    { key: "no", value: "No" },
];

function VirtualTerminal(props) {
    const { onChange, value } = props;
    return (
        <SlidingButton
            handleChange={(_e, v) => onChange("virtual_terminal_default", v)}
            title="Virtual Terminal?"
            value={value}
            options={options}
        />
    );
}

export default VirtualTerminal;
